import Monogram from "./Monogram";
import { useCopy } from "../i18n";

export const Footer = () => {
  const copy = useCopy();
  return (
    <footer data-testid="site-footer" className="border-t border-[rgba(251,251,249,0.12)] bg-[#1E2A38] text-[#FBFBF9]">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 px-6 py-10 sm:flex-row">
        <div className="flex items-center gap-3 text-[#FBFBF9]/80">
          <Monogram className="h-8 w-8" />
          <span className="font-serif-display text-lg italic">Stefano Plaia</span>
        </div>
        <p className="text-xs text-[#FBFBF9]/50">{copy.footer.credit}</p>
        <div className="flex items-center gap-6 text-xs">
          <a
            href="https://www.linkedin.com/in/stefano-plaia/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin"
            className="text-[#FBFBF9]/70 transition-colors duration-300 hover:text-[#B89762]"
          >
            {copy.footer.linkedin}
          </a>
          <a
            href="mailto:stefano.plaia@hotmail.it"
            data-testid="footer-email"
            className="text-[#FBFBF9]/70 transition-colors duration-300 hover:text-[#B89762]"
          >
            {copy.footer.email}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
